import produce from 'immer'
import { assign } from 'lodash'

import { createTreeSelectOptions } from '../../helpers'
import { COMMON_FETCH_COURSE_TYPES } from '../action-types'
import { COURSE_TYPES_INITIAL_STATE } from '../initial-states'

const courseTypesReducer = (state = COURSE_TYPES_INITIAL_STATE, action) => {
  switch (action.type) {
    case COMMON_FETCH_COURSE_TYPES.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: undefined,
          options: undefined,
        }),
      )

    case COMMON_FETCH_COURSE_TYPES.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: action.payload.data.courseTypes.results,
          options: createTreeSelectOptions(
            action.payload.data.courseTypes.results,
            'name',
            'id',
          ),
        }),
      )

    case COMMON_FETCH_COURSE_TYPES.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: undefined,
          options: undefined,
        }),
      )

    case COMMON_FETCH_COURSE_TYPES.CLEANUP:
      return { ...COURSE_TYPES_INITIAL_STATE }

    default:
      return state
  }
}

export default courseTypesReducer
